import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'groupBy'})
export class GroupByPipe implements PipeTransform {
    transform(value: Array<any>, field: string): Array<any> {
        // value = value.reduce((a, c) => {
        //     if (!a.has(c.group)) {
        //         a.set(c.group, {
        //             id: c.group,
        //             name: c.group_name,
        //             values: []
        //         });
        //     }
        //
        //     let data = a.get(c.group);
        //     data.values.push(c);
        //     a.set(c.group_name, data);
        //     return a;
        // }, new Map());
        //
        // return Array.from(value.values());

        const groupedObj = value.reduce((prev, cur)=> {
            if(!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            } else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});

        return Object.keys(groupedObj).map(group => ({ group, group_name: groupedObj[group][0].group_name, value: groupedObj[group] }));
    }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/group-by.pipe.ts